import { ChangeDetectionStrategy, Component, HostListener, inject } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';
import { NotificationService } from '../notification.service';
import { ConfirmVariant } from '../notification.models';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [IonIcon],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent {
  private readonly notification = inject(NotificationService);

  readonly request = this.notification.confirmRequest;

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.request()) {
      this.cancel();
    }
  }

  onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.cancel();
    }
  }

  cancel(): void {
    this.notification.resolveConfirm(false);
  }

  onConfirm(): void {
    this.notification.resolveConfirm(true);
  }

  confirmButtonClass(variant: ConfirmVariant): string {
    if (variant === 'danger') {
      return 'bg-red-600 text-white hover:bg-red-700 focus-visible:ring-red-500/30';
    }

    return 'bg-[#14241e] text-white hover:bg-[#1a2e26] focus-visible:ring-[#14241e]/30';
  }
}
